import { MinusOutlined } from "@ant-design/icons";
import { Anchor, Col, Flex, Row, Tooltip } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAuthContext } from "../../contexts/AuthContext";
import { useGlobalFilterContext } from "../../contexts/GlobalFilterProvider";
import logger from "../../server/server";
import { PageContent, PageSection } from "../../styles/global/Pages.styled";
import Theme from "../../styles/Theme/Theme";
import { RIGHT_CONTENT_ID } from "./Home";
import { HomepageCharts } from "../Global/Molecules/Homepage/HomepageCharts";

export const Homepage = () => {
  const { t } = useTranslation();
  const { dropdownEntity, entity, dropdownSubEntity, subEntity, setSubEntity,
    classes, setClasses, dropdownClasses, isClassesFetching, layersDropdown, selectedLayer, setSelectedLayer, items, setIsClassesFetching } = useGlobalFilterContext();
  const { user, tenant } = useAuthContext();
  const areas = ['Parking', 'Energy', 'Green Spaces', 'Water', 'Environment'];

  useEffect(() => {
    if (selectedLayer === "IVP" || selectedLayer === "OVP") {
      setIsClassesFetching(true);
      setSelectedLayer(layersDropdown[0].value);
    };
  }, []);

  const dropdownItems = layersDropdown.filter(x => x.value !== "IVP" && x.value !== "OVP").map((item, index) => (
    <li onClick={() => { setIsClassesFetching(true); setSelectedLayer(item.value) }} key={index}
      style={{ fontWeight: item.value === selectedLayer ? '500' : null }}>{t('button.' + item.label)}</li>
  ));

  useEffect(() => {
    logger.info("User " + user + " entered HomePage successfully! Tenant: " + tenant);
  }, [user]);

  return (
    <PageContent $backgroundColor="neutral-1">
      <PageSection style={{ position: "fixed", top: "88px", zIndex: "1000", backgroundColor: Theme.color["neutral-1"], width: "-webkit-fill-available" }} $paddingBottom={Theme.spacing['s02']}>
        <Row gutter={[16]}>
          <Col span={24} style={{ marginBottom: "10px" }}>
            <Anchor
              direction="horizontal"
              getContainer={() => document.getElementById(RIGHT_CONTENT_ID)}
              targetOffset={130}
              items={areas?.map((area, index) => ({
                key: area,
                title: (
                  <span key={index}>
                    <span>{t(area)}</span>
                    {index < areas.length - 1 && <MinusOutlined style={{ marginLeft: "10px" }} />}
                  </span>
                ),
                href: '#' + area.toLowerCase(),
              }))}
            />
          </Col>
        </Row>
      </PageSection>

      <PageSection className="first-section" style={{ marginTop: "65px" }}>
        <HomepageCharts />
      </PageSection>
    </PageContent>
  );
};